// Shared helpers for the role/user assignment tabs in the edit dialogs.

export const sortIds = (ids: number[]): number[] => [...ids].sort((a, b) => a - b);

/**
 * Order-independent equality for two lists of numeric ids. Used to decide
 * whether an assignment set actually changed before issuing a save request.
 */
export const haveSameIds = (left: number[], right: number[]): boolean => {
  const sortedLeft = sortIds(left);
  const sortedRight = sortIds(right);

  return sortedLeft.length === sortedRight.length && sortedLeft.every((id, index) => id === sortedRight[index]);
};
